import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext';

export default function ClubCreationSucces() {
    const navi = useNavigate()
    const {user} = useAuthContext()
    return (
      <div className="container text-center mt-5 bg-white">
        <div className='blueBanner'>
        <p className="p-2 fw-bold">Club Created Successfully!</p>
        </div>
         
        <p className="lead text-muted">
                Your club has been successfully created. You can view and manage your clubs by clicking the button below.
            </p>
          <button 
              className="saveChanges-button mb-5"
              onClick={() => navi(`/myclubs/${user.id}`)}
          >
                 My Clubs
          </button>
      </div>
  );
}
